var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard-editor-container" },
    [
      _c(
        "el-row",
        { staticClass: "panel-group main", attrs: { gutter: 40 } },
        [
          _c(
            "el-col",
            {
              staticClass: "panel-group no-padding-left",
              attrs: { xs: 24, sm: 24, lg: 15 }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  staticClass: "card-panel left-height"
                },
                [
                  !_vm.loading
                    ? _c(
                        "div",
                        { staticClass: "load-up left-panel-container" },
                        [
                          _c("div", { staticClass: "upper-section" }, [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/images/pigeon-logo.jpg"),
                                alt: "",
                                width: "150",
                                height: "150"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "profile" }, [
                              _c("div", { staticClass: "greeting" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("dashboard.goodAfternoon")) +
                                    "，" +
                                    _vm._s(
                                      _vm.$store.getters.account
                                        ? _vm.$store.getters.account.userName
                                        : "-"
                                    ) +
                                    "，" +
                                    _vm._s(_vm.$t("dashboard.welcome")) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "info",
                                  staticStyle: { display: "flex" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { width: "130px" } },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t("dashboard.lastLoginTime")
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "\n                  ：" +
                                        _vm._s(_vm.data.lastLoginTime) +
                                        "\n                "
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticStyle: { display: "flex" } }, [
                                _c("div", { staticStyle: { width: "130px" } }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("dashboard.lastLoginIp")) +
                                      "\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n                  ：" +
                                      _vm._s(_vm.data.lastLoginIp) +
                                      "\n                "
                                  )
                                ])
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "lower-section" },
                            _vm._l(_vm.cardInfo, function(pair, i) {
                              return _c("CardInfo", {
                                key: i,
                                attrs: { pair: pair }
                              })
                            }),
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "el-col",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticClass: "panel-group info-panel no-padding-right",
              attrs: { xs: 24, sm: 24, lg: 9 }
            },
            [
              !_vm.loading
                ? _c(
                    "div",
                    {
                      staticClass: "load-up card-panel left-height info-panel"
                    },
                    [
                      _c("div", { staticClass: "wrapper" }, [
                        _c("div", { staticClass: "info-panel-title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("dashboard.merchant.companyInformation")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "el-table",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  data: _vm.tableData.filter(function(data) {
                                    return data.value !== ""
                                  }),
                                  stripe: _vm.$store.getters.stripeConf,
                                  border: _vm.$store.getters.borderConf
                                }
                              },
                              [
                                _c("el-table-column", {
                                  attrs: { prop: "label", label: "Label" }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: { prop: "value", label: "Value" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            scope.row.tag
                                              ? _c(
                                                  "el-tag",
                                                  {
                                                    attrs: {
                                                      type: scope.row.type
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(scope.row.value)
                                                    )
                                                  ]
                                                )
                                              : scope.row.button
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    attrs: { type: "success" },
                                                    on: {
                                                      click: _vm.redirectToDocs
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "dashboard.merchant.redirectToDocs"
                                                        )
                                                      ) + "\n                  "
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  [
                                                    _c(
                                                      "el-popover",
                                                      {
                                                        attrs: {
                                                          trigger: "click",
                                                          content:
                                                            scope.row.value
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "ellipsis",
                                                            attrs: {
                                                              slot: "reference"
                                                            },
                                                            slot: "reference"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row.value
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    2991848267
                                  )
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: {
            background: "#fff",
            padding: "16px 16px 0",
            "margin-bottom": "32px"
          }
        },
        [
          _c("div", { staticClass: "graph-title" }, [
            _vm._v(_vm._s(_vm.$t("dashboard.merchant.top5Pay")))
          ]),
          _vm._v(" "),
          _vm.values.filter(function(v) {
            return v !== 0
          }).length
            ? _c("bar-chart", {
                ref: "barChart",
                attrs: {
                  labels: _vm.labels,
                  values: _vm.values,
                  placeholder: _vm.$t("dashboard.merchant.numSuccesses")
                }
              })
            : _c("div", { staticClass: "no-data" }, [
                _vm._v(_vm._s(_vm.$t("common.noData")))
              ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }